import { Group, Stack, Text } from '@mantine/core'
import React from 'react'
import { useTheme } from '../../components/ThemeProvider'

interface HitItemProps {
  name: string
  hitCount?: number
  recentHitTime?: string
}

export default function HitItem({ name, hitCount = 0, recentHitTime = '-' }: HitItemProps) {
  const theme = useTheme()

  return (
    <Stack gap={6}>
      <Group justify="space-between" align="flex-end">
        <Text size="sm" className="text-gray-700 whitespace-nowrap">
          {name}
        </Text>
      </Group>
      <div
        className="grid grid-cols-2 gap-3 rounded-md border px-3 py-2 text-xs text-gray-600"
        style={{ borderColor: theme.surfaceBorderColor, backgroundColor: theme.surfaceColor }}
      >
        <div>
          <Text size="xs" c="dimmed">
            命中次数
          </Text>
          <Text size="sm" fw={600} className="text-gray-700">
            {hitCount} 次
          </Text>
        </div>
        <div>
          <Text size="xs" c="dimmed">
            最近时间
          </Text>
          <Text size="sm" fw={600} className="text-gray-700">
            {recentHitTime}
          </Text>
        </div>
      </div>
    </Stack>
  )
}
